import { render, staticRenderFns } from "./EffectDisplay.vue?vue&type=template&id=69daf308&"
import script from "./EffectDisplay.vue?vue&type=script&lang=js&"
export * from "./EffectDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports